"use client";

import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Image as ImageIcon } from "lucide-react";

export const HolidayCardLoadingSkeleton = ({
  viewMode = "grid",
}: {
  viewMode?: "grid" | "list";
}) => {
  if (viewMode === "grid") {
    return (
      <div className="flex h-full w-full flex-col overflow-hidden rounded-2xl border border-border/70 bg-card p-0 shadow-xs">
        <div className="relative flex h-44 w-full items-center justify-center bg-muted/40">
          <div className="rounded-full border border-background/40 bg-muted/80 p-3">
            <ImageIcon className="size-5 text-muted-foreground/40" />
          </div>
          <div className="absolute left-2.5 top-2.5">
            <Skeleton className="h-4 w-16 rounded-full" />
          </div>
        </div>

        <div className="flex flex-1 flex-col justify-start gap-2.5 p-3.5 sm:p-4">
          <Skeleton className="h-5 w-4/5 rounded-md" />
          <Skeleton className="h-3.5 w-1/2 rounded-md" />

          <div className="flex items-center gap-1.5 pt-0.5">
            <Skeleton className="h-5 w-16 rounded-md" />
            <Skeleton className="h-5 w-20 rounded-md" />
          </div>
        </div>

        <div className="mt-auto border-t border-border/50 bg-muted/20 px-3.5 py-2.5 dark:bg-muted/10 flex items-center justify-between">
          <div className="space-y-1">
            <Skeleton className="h-2 w-14 rounded" />
            <Skeleton className="h-4 w-20 rounded-md" />
          </div>
          <Skeleton className="h-8 w-20 rounded-lg" />
        </div>
      </div>
    );
  }

  return (
    <div className="w-full overflow-hidden rounded-2xl border border-border/70 bg-card p-0 shadow-xs">
      <div className="grid grid-cols-1 md:grid-cols-[240px_minmax(0,1fr)] lg:grid-cols-[260px_minmax(0,1fr)_260px]">
        {/* Image + Details skeleton */}
        <div className="grid grid-cols-1 md:grid-cols-[minmax(0,240px)_minmax(0,1fr)]">
          <div className="relative flex h-52 w-full items-center justify-center bg-muted/40 md:h-full md:min-h-[190px]">
            <div className="rounded-full border border-background/40 bg-muted/80 p-3">
              <ImageIcon className="size-5 text-muted-foreground/40" />
            </div>
            <div className="absolute left-3 top-3">
              <Skeleton className="h-5 w-20 rounded-full" />
            </div>
          </div>

          <div className="flex min-w-0 flex-col justify-between gap-3 px-4 py-4 md:px-5">
            <div className="space-y-2.5">
              <Skeleton className="h-6 w-3/4 rounded-md" />
              <Skeleton className="h-4 w-1/2 rounded-md" />

              <div className="flex flex-wrap gap-2 pt-1">
                <Skeleton className="h-7 w-28 rounded-full" />
                <Skeleton className="h-7 w-24 rounded-full" />
              </div>
            </div>

            <div className="flex items-center gap-1.5 pt-1">
              <Skeleton className="h-5 w-16 rounded-full" />
              <Skeleton className="h-5 w-16 rounded-full" />
            </div>
          </div>
        </div>

        {/* Pricing sidebar skeleton */}
        <div className="p-4 md:p-5 flex flex-col justify-between gap-4 xl:items-end">
          <div className="space-y-1.5 w-full xl:items-end flex flex-col">
            <Skeleton className="h-3 w-24 rounded" />
            <Skeleton className="h-7 w-32 rounded-md" />
            <Skeleton className="h-3 w-16 rounded" />
          </div>

          <div className="w-full">
            <Skeleton className="h-10 w-full rounded-lg" />
          </div>
        </div>
      </div>
    </div>
  );
};


